import PickerView from './PickerView';
export default PickerView;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/picker-view/index.js
// module id = 388
// module chunks = 0